import React, { useEffect, useState, useRef } from "react";
import { Header, Grid, Divider, Button, Form } from "semantic-ui-react";
import { useNavigate } from "react-router";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import axios from "axios";
import { BaseUrl, BaseUrlInvoice } from "../formcomponents/Constants";
import { userData } from "../store/userData";
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";
import Swal from "sweetalert2";
const ListReciveMoneyWithCat = (props) => {
  const { categoryId } = props;
  const navigate = useNavigate();
  const createNew = () => {
    navigate(`/recive-money/null/${categoryId}`);
  };

  const gridApiRef = useRef(null); // Use Ref for gridApi
  const [rowData, setrowData] = useState(null);
  const userDetail = userData();
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [fullData, setfullData] = useState();
  const [getFilterTotal, setgetFilterTotal] = useState(null);
  const [getFilter, setgetFilter] = useState(false);
  const [primaryTotal, setprimaryTotal] = useState();
  const agGridRef = useRef(null);

  useEffect(() => {
    getReciveMoneyList();
  }, []);

  const getReciveMoneyList = () => {
    //     Get Methods:
    // /listInvoice
    // /listSpendMoney
    // /listReceiveMoney

    const postObject = {
      categoryId: categoryId,
      getAll: categoryId === 0 ? true : false,
      dateFilter: fromDate != "" && toDate != "" ? true : false,
      startDate: fromDate,
      endDate: toDate,
    };

    console.log("postObject", postObject);
    axios
      .post(BaseUrlInvoice + "accounts/listReceiveMoney", postObject)
      .then((res) => {
        setfullData(res.data);
        setRecordForTable(res.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };
  const setRecordForTable = (record) => {
    let tempRecord = [];
    let grandTotal = 0;
    for (let i = 0; i < record.length; i++) {
      let receivedFrom = record[i].receivedFrom,
        receivedOn = record[i].receivedOn,
        totalAmount = record[i].totalAmount,
        receivedAs = getString(record[i].receivedAs),
        receiveMoneyId = record[i].receiveMoneyId,
        remarks = record[i].remarks;
      if (record[i].itemList) {
        for (let j = 0; j < record[i].itemList.length; j++) {
          let amount = parseFloat(record[i].itemList[j].amount); // Get the amount here
          grandTotal += amount; // Add the amount to the grandTotal
          tempRecord.push({
            receiveMoneyId: receiveMoneyId,
            receivedAs: receivedAs,
            receivedOn: receivedOn
              ? new Date(receivedOn).toLocaleDateString("en-GB")
              : "",
            // record[i].invoiceDate
            // ? new Date(record[i].invoiceDate).toLocaleDateString("en-GB")
            //: "",
            receivedFrom: receivedFrom,
            receiveDetails: record[i].itemList[j].itemName,
            itemDescription: record[i].itemList[j].itemDescription,
            itemQty: record[i].itemList[j].itemQty,
            unitPrice: record[i].itemList[j].unitPrice,
            disPer: record[i].itemList[j].disPer,
            amount: record[i].itemList[j].amount,
            remarks: remarks,
          });
        }
      }
    }

    tempRecord.push({
      receiveMoneyId: "",
      receivedOn: "",
      receivedFrom: "",
      receiveDetails: "",
      itemDescription: "",
      itemQty: "",
      unitPrice: "",
      disPer: "FINAL TOTAL",
      amount: grandTotal,
      remarks: "",
    });

    console.log("tempRecord", tempRecord);
    setgetFilterTotal(tempRecord);
    setrowData(tempRecord);

    // let formattedNum = grandTotal;

    // if (Number.isFinite(grandTotal)) {
    //   // Check if num is a finite number
    //   if (grandTotal % 1 === 0) {
    //     // Check if num is an integer
    //     formattedNum = grandTotal.toFixed(2);
    //   }
    // }
    setprimaryTotal(grandTotal.toFixed(2));
  };

  const filterToatlAmount = (record) => {
    let tempRecord = [];
    let grandTotal = 0;
    for (let i = 0; i < record.length; i++) {
      let receivedFrom = record[i].receivedFrom,
        receivedOn = record[i].receivedOn,
        totalAmount = record[i].totalAmount,
        receivedAs = getString(record[i].receivedAs),
        receiveMoneyId = record[i].receiveMoneyId;
      if (record[i].itemList) {
        for (let j = 0; j < record[i].itemList.length; j++) {
          let amount = parseFloat(record[i].itemList[j].amount); // Get the amount here
          grandTotal += amount; // Add the amount to the grandTotal
          tempRecord.push({
            receiveMoneyId: receiveMoneyId,
            receivedAs: receivedAs,
            receivedOn: receivedOn
              ? new Date(receivedOn).toLocaleDateString("en-GB")
              : "",
            // record[i].invoiceDate
            // ? new Date(record[i].invoiceDate).toLocaleDateString("en-GB")
            //: "",
            receivedFrom: receivedFrom,
            itemName: record[i].itemList[j].itemName,
            itemDescription: record[i].itemList[j].itemDescription,
            itemQty: record[i].itemList[j].itemQty,
            unitPrice: record[i].itemList[j].unitPrice,
            disPer: record[i].itemList[j].disPer,
            amount: record[i].itemList[j].amount,
          });
        }
      }
    }

    tempRecord.push({
      receiveMoneyId: "",
      receivedOn: "",
      receivedFrom: "",
      itemName: "",
      itemDescription: "",
      itemQty: "",
      unitPrice: "",
      disPer: "FINAL TOTAL",
      amount: grandTotal,
    });

    console.log("tempRecord", tempRecord);
    setgetFilterTotal(tempRecord);
  };

  const getString = (id) => {
    if (id == 1) {
      return "Cash";
    } else if (id == 2) {
      return "Credi Card";
    } else if (id == 3) {
      return "Cheque";
    } else if (id == 4) {
      return "Payment Link";
    } else if (id == 5) {
      return "Bank Transfer";
    } else if (id == 6) {
      return "BankTransferTO ENBD";
    } else if (id == 7) {
      return "Bank Transfer TO Rak Bank";
    }
  };
  const receivedAsvalue = (value) => {
    if (value === 1) {
      return "Direct Payment";
    } else if (value === 2) {
      return "Pre Payment";
    } else if (value === 3) {
      return "Over Payment";
    }
  };
  const amountsAreValue = (value) => {
    if (value === 1) {
      return "Tax Exclusive";
    } else if (value === 2) {
      return "Tax Inclusive";
    } else if (value === 3) {
      return "No Tax";
    }
  };
  const columnDefs = [
    { headerName: "Date ", field: "receivedOn", flex: 2 },
    { headerName: "From", field: "receivedFrom", flex: 3 },
    { headerName: "Receive Account", field: "receiveDetails", flex: 3 },
    { headerName: "Description", field: "itemDescription", flex: 3 },
    { headerName: "Quantity", field: "itemQty", flex: 2 },
    { headerName: "UnitPrice", field: "unitPrice", flex: 2 },
    { headerName: "Discount", field: "disPer", flex: 2 },
    { headerName: "Amount", field: "amount", flex: 2 },
    {
      headerName: "Actions",
      filter: false,
      field: "receiveMoneyId",
      cellRendererFramework: (params) => (
        <div>
          <Button color="primary" onClick={() => actionButton(params)}>
            View{" "}
          </Button>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          {userDetail.userRole == 1 && (
            <Button color="red" onClick={() => deleteItem(params)}>
              delete
            </Button>
          )}
        </div>
      ),
    },
  ];
  const actionButton = (params) => {
    navigate(`/recive-money/${params.data.receiveMoneyId}/${categoryId}`);
    // history.push(
    //   `/attraction/attraction-creation/${params.data.attractionsId}`
    // ); /
  };
  const deleteItem = (params) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        // Swal.fire("Deleted!", "Your file has been deleted.", "success");
        axios
          .post(BaseUrlInvoice + "accounts/deleteReceiveMoney", {
            receiveMoneyId: params.data.receiveMoneyId,
          })
          .then((res) => {
            Swal.fire("Deleted!", "Record has been deleted.", "success");
            getReciveMoneyList();
          })
          .catch((error) => {
            console.log(error);
          });
      }
    });
  };

  const defaultColDef = {
    sortable: true,
    editable: true,
    // flex: 1,
    filter: true,
    floatingFilter: true,
  };

  const fileType =
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
  const fileExtension = ".xlsx";

  const exportToCSV = () => {
    const filteredRows = [];
    gridApiRef.current?.forEachNodeAfterFilterAndSort((rowNode) => {
      filteredRows.push(rowNode.data);
    });

    const ws = XLSX.utils.json_to_sheet(filteredRows);
    const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], { type: fileType });
    FileSaver.saveAs(data, "Contact_List" + fileExtension);
  };

  const onGridReady = (params) => {
    gridApiRef.current = params.api;
  };

  const getFilteredData = () => {
    if (getFilter === false) {
      const gridApi = agGridRef.current.api;
      const filteredRows = gridApi.getModel().rowsToDisplay;
      const tempArr = filteredRows.map((rowNode) => rowNode.data);
      const filteredArr = fullData.filter((item1) =>
        tempArr.some((item2) => item1.receiveMoneyId === item2.receiveMoneyId)
      );

      filterToatlAmount(filteredArr);
    } else {
      filterToatlAmount(fullData);
    }

    setgetFilter(!getFilter);
  };

  return (
    <div>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        <div>
          <Grid.Row>
            {categoryId != 0 && (
              <Button type="submit" primary onClick={() => createNew()}>
                Create New
              </Button>
            )}

            <Button
              color="primary"
              onClick={(e) => exportToCSV(rowData, "Recive_Money_List")}
            >
              Export Excel
            </Button>
          </Grid.Row>
        </div>
        <div
          style={{
            display: "flex",
          }}
        >
          <Form.Input
            name="from"
            label="from"
            type="date"
            value={fromDate}
            onChange={(e) => setFromDate(e.target.value)}
          />
          <Form.Input
            name="to"
            label="To"
            type="date"
            value={toDate}
            onChange={(e) => setToDate(e.target.value)}
          />
          <Button color="primary" onClick={() => getReciveMoneyList()}>
            Filter Search
          </Button>
        </div>
      </div>
      <Divider hidden /> <Divider hidden />
      <Grid.Row>
        <div className="ag-theme-alpine" style={{ height: 600 }}>
          <AgGridReact
            ref={agGridRef}
            rowData={rowData}
            columnDefs={columnDefs}
            defaultColDef={defaultColDef}
            pagination={true}
            onGridReady={onGridReady}
          ></AgGridReact>
        </div>

        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <div
            style={{
              display: "flex",
            }}
          >
            <Button color="primary" onClick={() => getFilteredData()}>
              {getFilter === false ? "GET TOTAL" : "GET FULL TOTAL"}
            </Button>
            <h2>
              Total :{" "}
              {getFilterTotal &&
                getFilterTotal[getFilterTotal.length - 1].amount.toFixed(2)}
            </h2>
          </div>
          <div>
            {" "}
            <h2>Total : {primaryTotal}</h2>
          </div>
        </div>
      </Grid.Row>
    </div>
  );
};

export default ListReciveMoneyWithCat;
